import LoginView from './LoginView';
import './LoginView.scss';

export default LoginView;
